import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Chip,
  Checkbox,
  FormControlLabel,
  Alert,
  RadioGroup,
  Radio
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import { useDispatch, useSelector } from "react-redux";
import { UpdateAccount } from "store/slice/usersSlice";

const AccountDetails = () => {
    const dispatch = useDispatch();
    const userStore = useSelector(store => store.user);
    const user = userStore.user;

    const passwordValidationSchema = Yup.object().shape({
   
    });
    const handleSubmit = (values) => {
        dispatch(UpdateAccount({...user, ...values}))
        // dispatch(UpdatePassword({password: values.currentPassword, token: token}))  
    };
    return(
        <Formik
            initialValues={{
                email: user?.email || "",
                name: user?.name || "",
                phone: user?.phone || "",
                gender: user?.gender || ""
            }}
            validationSchema={passwordValidationSchema}
            onSubmit={handleSubmit}
        >
            {({ errors, touched, handleChange, handleBlur, values }) => {
                return (
                <Form>
                    <Grid container spacing={3}>
                    <Grid item size={{ xs: 12 }}>
                        <TextField
                        fullWidth
                        label="Email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.email && Boolean(errors.email)}
                        helperText={touched.email && errors.email}
                        variant="outlined"
                        />
                    </Grid>

                    <Grid item size={{ xs: 12 }}>
                        <Typography variant="body2">Gender</Typography>
                        <RadioGroup
                        row
                        name="gender"
                        value={values.gender}
                        onChange={handleChange}
                        >
                        <FormControlLabel value="male" control={<Radio />} label="Male" />
                        <FormControlLabel value="female" control={<Radio />} label="Female" />
                        </RadioGroup>
                        {touched.gender && errors.gender && (
                        <Typography color="error">{errors.gender}</Typography>
                        )}
                    </Grid>

                    <Grid item size={{ xs: 12 }}>
                        <TextField
                        fullWidth
                        label="Name"
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                        variant="outlined"
                        />
                    </Grid>

                    <Grid item size={{ xs: 12 }}>
                        <TextField
                        fullWidth
                        label="Phone"
                        name="phone"
                        value={values.phone}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.phone && Boolean(errors.phone)}
                        helperText={touched.phone && errors.phone}
                        variant="outlined"
                        />
                    </Grid>

                    <Grid item size={{ xs: 12 }}>
                        <Button type="submit" variant="contained" color="primary">
                        Save Changes
                        </Button>
                    </Grid>
                    </Grid>
                </Form>
                );
            }}
            </Formik>

    )
}

export default AccountDetails;